import { Box, Paper, Typography, useTheme } from "@mui/material";
import {
  authLogoStyles,
  authPageContainerStyles,
  authPaperStyles,
  authTitleStyles,
} from "../styles/commonStyles";
import logoGreen from "../assets/images/logo_smaart_green.png";
import ChangePasswordForm from "../components/forms/changePasswordForm.component";

const ChangePasswordPage = () => {
  const theme = useTheme();

  return (
    <Box sx={authPageContainerStyles(theme)}>
      <Paper sx={authPaperStyles}>
        <Box sx={authTitleStyles}>CAMBIO PASSWORD</Box>
        <Box
          component="img"
          src={logoGreen}
          alt="Smaart Logo"
          sx={authLogoStyles}
        />
        <Box width="100%">
          <Typography fontWeight={400} fontSize="12px">
            Scegli la tua nuova password per accedere al portale
          </Typography>
        </Box>
        <ChangePasswordForm />
      </Paper>
    </Box>
  );
};

export default ChangePasswordPage;
